var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { ColumnFilterMenu } from './ColumnFilterMenu';
var HeaderBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
});
var HeaderLabel = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        fontWeight: theme.typography.fontWeightBold,
        fontSize: theme.typography.body1.fontSize,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 1,
    });
});
var FilterButton = styled(IconButton, {
    shouldForwardProp: function (prop) { return prop !== 'active'; },
})(function (_a) {
    var theme = _a.theme, active = _a.active;
    return ({
        padding: theme.spacing(1),
        color: 'inherit',
        opacity: active ? 1 : 0.55,
        flexShrink: 0,
        '&:hover': { opacity: 1, backgroundColor: 'transparent' },
    });
});
export var ColumnFilterHeader = function (_a) {
    var label = _a.label, filterState = _a.filterState, allValues = _a.allValues, onApply = _a.onApply;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var hasControls = filterState.sortable || !!filterState.kind;
    var hasDateRange = !!filterState.dateRange && (!!filterState.dateRange.from || !!filterState.dateRange.to);
    var isActive = filterState.sort !== null || filterState.selectedValues !== null || !!filterState.contains || hasDateRange;
    // Columns with neither sort nor filter render as a plain label (e.g. display-only status).
    if (!hasControls) {
        return _jsx(HeaderLabel, { children: label });
    }
    return (_jsxs(_Fragment, { children: [_jsxs(HeaderBox, { children: [_jsx(HeaderLabel, { children: label }), _jsx(FilterButton, __assign({ active: isActive, size: "small", onClick: function (e) {
                            e.stopPropagation();
                            setAnchorEl(e.currentTarget);
                        }, "aria-label": "Filter ".concat(label) }, { children: _jsx(FontAwesomeIcon, { icon: "filter", size: "xs" }) }))] }), _jsx(ColumnFilterMenu, { anchorEl: anchorEl, open: !!anchorEl, onClose: function () { return setAnchorEl(null); }, sortable: filterState.sortable, kind: filterState.kind, currentSort: filterState.sort, allValues: allValues, currentSelectedValues: filterState.selectedValues, currentContains: filterState.contains, currentDateRange: filterState.dateRange, onApply: onApply })] }));
};
